import { RefObject } from 'react';

import useVerticalScrollbar from '@/shared/lib/hooks/useVerticalScrollbar';

const useDataGridVerticalScrollbar = (
  containerRef: RefObject<HTMLElement | null>,
  dataGridKey?: string | number,
  enabled?: boolean,
) => {
  useVerticalScrollbar(containerRef, {
    enabled,
    alwaysSolid: true,
    compactLayout: true,
    getScroller: (container) =>
      container.querySelector<HTMLElement>('.MuiDataGrid-virtualScroller'),
    getTrackParent: (_scroller, container) => container,
    getContentElement: (scroller) =>
      scroller.querySelector<HTMLElement>('.MuiDataGrid-virtualScrollerContent'),
    getTrackBounds: (scroller, container) => {
      const containerRect = container.getBoundingClientRect();
      const columnHeaders = container.querySelector<HTMLElement>('.MuiDataGrid-columnHeaders');
      if (!columnHeaders) return { top: 0, height: scroller.clientHeight };
      const headerBottom = columnHeaders.getBoundingClientRect().bottom;
      const scrollerRect = scroller.getBoundingClientRect();
      return {
        top: headerBottom - containerRect.top,
        height: Math.max(0, scrollerRect.top + scroller.clientHeight - headerBottom),
      };
    },
    key: dataGridKey,
  });
};

export default useDataGridVerticalScrollbar;
